import React from 'react';
import styled from 'styled-components';
import { NavLink } from 'react-router-dom';
import { colors } from '../../variables';

const getColor = (props, state) => {
	if (props.active || state === 'hover') return colors.blue.brommaLight;
	return colors.grey.normal;
};

const getBorderColor = (props, state) => {
	if (props.active || state === 'hover') return colors.blue.brommaLight;
	return '#fff';
};

const Tab = styled.li`
	display: inline-block;
	margin: 0 10px;

	a {
		text-transform: uppercase;
		font-weight: 700;
		display: block;
		cursor: pointer;
		padding: 10px 0;
		letter-spacing: 1px;
		color: ${props => getColor(props)};
		border-bottom: 3px solid ${props => getBorderColor(props)};
		transition: color 0.2s ease-out, border-color 0.2s ease-out;
		text-decoration: none;
	}

	&:hover a,
	&:focus a,
	a.active {
		color: ${props => getColor(props, 'hover')};
		border-color: ${props => getBorderColor(props, 'hover')};
	}
`;

class TabComponent extends React.Component {
	render() {
		const {
			children,
			className,
			active,
			type = 'default',
			...rest
		} = this.props;

		return (
			<Tab className={className} active={active}>
				{type === 'NavLink' && <NavLink {...rest}>{children}</NavLink>}

				{type === 'default' && (
					<a {...rest} role="button">
						{children}
					</a>
				)}
			</Tab>
		);
	}
}

export default TabComponent;



// WEBPACK FOOTER //
// ./src/components/Common/Tab/Tab.js